// extracted by mini-css-extract-plugin
module.exports = {"container":"error404_container__844vJ","contain":"error404_contain__32W1r","btn":"error404_btn__2HkB9"};